function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

document.querySelectorAll(".quick-add-button-variants").forEach((e) => {
  e.addEventListener("click", function () {
    waitForElm(".product-single-wrapper").then((elm) => {
      document.querySelectorAll(".accordion_head").forEach((e) => {
        e.addEventListener("click", function () {
          if (this.nextElementSibling.style.display === "none") {
            this.nextElementSibling.style.display = "block";
            this.querySelector(".plusminus").innerHTML = "-";
          } else {
            this.nextElementSibling.style.display = "none";
            this.querySelector(".plusminus").innerHTML = "+";
          }
        });
      });
      console.log("gt");
    });
  });
});
